import { defineMessages } from 'react-intl'

const scope = `procurify.platform.comment.components.MessageThread`

export default defineMessages({
  retryLoad: {
    id: `${scope}.retryLoad`,
    defaultMessage: 'Retry',
  },
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Write a message...',
  },
  send: {
    id: `${scope}.send`,
    defaultMessage: 'Send message',
  },
  scrollToLatest: {
    id: `${scope}.scrollToLatest`,
    defaultMessage: 'Scroll to the latest message',
  },
  messageMeta: {
    id: `${scope}.messageMeta`,
    defaultMessage: '{author} - {timestamp}',
  },
})
